import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { BuildingStatus } from '../land/state'
import { initialCastle4State, Castle4State } from './state'

export const castle4Slice = createSlice({
  name: 'castle4',
  initialState: initialCastle4State as Castle4State,
  reducers: {
    setCastle4Loading: (state: Castle4State, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setCastle4ImmediateLoading: (state: Castle4State, action: PayloadAction<boolean>) => {
      state.isImmediate = action.payload
    },
    setCastle4Error: (state: Castle4State, action: PayloadAction<string | undefined>) => {
      state.error = action.payload
    },
    setCastle4BuildingStatus: (state: Castle4State, action: PayloadAction<Partial<BuildingStatus>>) => {
      const existingStatus = state.buildingStatus || initialCastle4State.buildingStatus
      const payload = action.payload
      
      const mergedStatus = { ...existingStatus } as Partial<BuildingStatus>
      
      for (const key in payload) {
        if (payload[key as keyof BuildingStatus]) {
          const existingBuilding = existingStatus[key as keyof BuildingStatus]
          const payloadBuilding = payload[key as keyof BuildingStatus]
          if (existingBuilding) {
            mergedStatus[key as keyof BuildingStatus] = {
              ...existingBuilding,
              ...payloadBuilding,
              hp: Number(payloadBuilding?.hp ?? 0),
              maxHp: Number(payloadBuilding?.maxHp ?? 0),
            } as any
          } else {
            mergedStatus[key as keyof BuildingStatus] = {
              ...payloadBuilding,
              hp: Number(payloadBuilding?.hp ?? 0),
              maxHp: Number(payloadBuilding?.maxHp ?? 0),
            } as any
          }
        }
      }
      
      state.buildingStatus = mergedStatus
    },
    setCastle4RepairRequirements: (state: Castle4State, action: PayloadAction<{ ecsToken: number; gem: number; stone: number; wood: number }>) => {
      state.repairRequirements = action.payload
    },
    setCastle4RestoreBuilding: (state: Castle4State) => {
      state.isRestored = true
    },
    setCastle4FetchSupportCharacters: (state: Castle4State, action: PayloadAction<any[]>) => {
      state.supportCharacters = action.payload
    },
    setCastle4SupportCharacters: (state: Castle4State, action: PayloadAction<any[]>) => {
      state.supportCharacters = [...state.supportCharacters, ...action.payload]
      state.isSetSupportCharacterSuccess = true
    },
    setCastle4ClearStatus: (state: Castle4State) => {
      state.isSetSupportCharacterSuccess = false
      state.error = undefined
    },
    setCastle4SupportState: (state: Castle4State, action: PayloadAction<boolean>) => {
      state.supportState = action.payload
    },
    setCastle4UpgradeBuilding: (state: Castle4State) => {
      state.upgradeAvailable = false
    },
    setCastle4UpgradeRequirements: (state: Castle4State, action: PayloadAction<{ ecsToken: number }>) => {
      state.upgradeRequirements = action.payload
    },
    setCastle4UpgradeAvailable: (state: Castle4State, action: PayloadAction<boolean>) => {
      state.upgradeAvailable = action.payload
    },
    setCastle4RemoveCharacterFromBuilding: (state: Castle4State, action: PayloadAction<{ success: boolean; building: string; character: string }>) => {
      // Handle character removal if needed
    },
    setCastle4AddCharacterToBuilding: (state: Castle4State, action: PayloadAction<{ success: boolean; building: string; character: string }>) => {
      // Handle character addition if needed
    },
    setCastle4AllMiningStatus: (state: Castle4State, action: PayloadAction<any>) => {
      state.allMiningStatus = action.payload
    },
  },
})

export const {
  setCastle4Loading,
  setCastle4ImmediateLoading,
  setCastle4Error,
  setCastle4BuildingStatus,
  setCastle4RepairRequirements,
  setCastle4RestoreBuilding,
  setCastle4FetchSupportCharacters,
  setCastle4SupportCharacters,
  setCastle4ClearStatus,
  setCastle4SupportState,
  setCastle4UpgradeBuilding,
  setCastle4UpgradeRequirements,
  setCastle4UpgradeAvailable,
  setCastle4RemoveCharacterFromBuilding,
  setCastle4AddCharacterToBuilding,
  setCastle4AllMiningStatus,
} = castle4Slice.actions

export default castle4Slice.reducer

